/**
 * Portal do Corretor dentro do sistema (antes era um link para o Google Sites).
 *
 * Os arquivos desta pasta vieram prontos (Downloads/PortalCorretor). O CSS original usa
 * seletores soltos (`body`, `main`, `h1`...) e o CSS do site é um bundle único: importado
 * como está, mudaria o visual do sistema inteiro. Por isso ele é servido já isolado em
 * `.pc-escopo` (portal-corretor.css, gerado por escopar-css.js) e tudo vive dentro deste
 * contêiner.
 *
 * Canal de Denúncias: o relato vai por e-mail ao RH (61imoveisrh@gmail.com) pela rota
 * `/canal-denuncias/relatos`. Relato anônimo não leva identificação nenhuma; o sistema
 * não guarda cópia (ver backend/app/services/canal_denuncias_service.py).
 */
import React, { useEffect } from 'react';
import { BASE } from '../../services/api';
import PortalCorretor from './PortalCorretor.jsx';
import './portal-corretor.css';

/** Só confirma sucesso quando o backend responde que o e-mail saiu (`accepted`). */
async function enviarRelato(payload) {
  const resposta = await fetch(`${BASE}/canal-denuncias/relatos`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const dados = await resposta.json().catch(() => ({}));
  if (!resposta.ok || dados.accepted !== true) throw new Error(dados.error || 'Envio não confirmado.');
  return dados;
}

export default function PortalCorretorPagina() {
  // O portal troca o título da aba a cada capítulo; ao sair, devolve o do sistema.
  useEffect(() => {
    const anterior = document.title;
    return () => { document.title = anterior; };
  }, []);

  return (
    <div className="pc-escopo">
      <PortalCorretor onSubmitReport={enviarRelato} />
    </div>
  );
}
